import { render, staticRenderFns } from "./TransactionComplete.vue?vue&type=template&id=16d2b87a&scoped=true&"
import script from "./TransactionComplete.vue?vue&type=script&lang=js&"
export * from "./TransactionComplete.vue?vue&type=script&lang=js&"
import style0 from "./TransactionComplete.vue?vue&type=style&index=0&id=16d2b87a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2b87a",
  null
  
)

export default component.exports